import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';
import { Compose } from '../../../Theme/CommonStyled';

export const StyledButton = styled.button<
  SpaceProps & {
    btnType: 'primaryGreen' | 'green' | 'blue';
    disabled?: boolean;
  }
>`
  font-family: IRANSans;
  width: 100%;
  border: none;
  position: relative;
  padding: 16px 18px;
  direction: rtl;
  display: flex;
  cursor: ${({ disabled }): string => (disabled ? 'not-allowed' : 'pointer')};
  align-items: center;
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  border-radius: ${({ theme }): string => theme.radii.xl};
  background-color: ${({ theme, btnType }): string =>
    btnType === 'green'
      ? theme.colors.secondaryGreen
      : btnType === 'blue'
      ? theme.colors.primaryBlue
      : btnType === 'red'
      ? theme.colors.danger
      : theme.colors.primaryGreen};
  color: ${({ theme, btnType }): string =>
    btnType === 'primaryGreen'
      ? theme.colors.buttonText
      : theme.colors.secondaryButtonText};
  ${Compose}

  :disabled {
    background-color: ${({ theme }): string => theme.colors.disableBg};
    color: ${({ theme }): string => theme.colors.secondaryButtonText};
  }
`;
